import type { LanguageCode } from '@elfsight/configurator-contracts';
import { type Country } from '../types';

const DEFAULT_COUNTRY_CODE = 'US';
const getCountryByLocale = (language: LanguageCode) => {
  const locale = new Intl.Locale(language);

  if (locale.region) {
    return locale.region;
  }
  const maximized = locale.maximize();
  return maximized.region;
};

export function getDefaultCountry(
  widgetLanguage: LanguageCode = 'en-US',
  countries: Country[]
) {
  const countryCode =
    getCountryByLocale(widgetLanguage) ??
    getCountryByLocale(navigator.language) ??
    DEFAULT_COUNTRY_CODE;
  const fallbackCountryCode = countryCode.toUpperCase();

  return (
    countries.find(({ countryCode }) => countryCode === fallbackCountryCode) ??
    countries.find(({ countryCode }) => countryCode === DEFAULT_COUNTRY_CODE) ??
    countries[0]
  );
}
